// extracted by mini-css-extract-plugin
export default {"Carousel":"CarouselCards_Carousel__QM17H","Carousel_title":"CarouselCards_Carousel_title__pobkH","Carousel_description":"CarouselCards_Carousel_description__PKbNs"};